/* cp-drop.js EU - kutija uzoraka gratis uz porudzbinu (Ivan 21.10.2026: "identicnu akciju sto imamo za Srbiju na EU").
   Mirko 21.10: klon SR cp-drop.js / EU cp-plus1.js. Poklon = free-sample-box-gift (0 EUR, Men's SKU-044-MEN,
   Women's SKU-044-WOMEN, Unisex SKU-chez-044 = obicna Sample kit, Ivan 21.10). Sam ulazi kad u korpi ima parfem
   (product_type Men/Women/Unisex), paket 3 for 55 ili placena Sample Box; izbor kutije u fioci i /cart; max 1.
   KAPIJA: 22.10 00:00 - 30.10 23:59:59 (Beograd); pre/posle samo uz ?cp_drop_preview=1 (TEST). */
(function () {
  var CP_POCETAK = 0; /* Ivan 21.10 23:56: 'odmah hocu' - start odmah (bilo 22.10 00:00) */
  var CP_KRAJ = 1793365060000; /* Ivan 30.10: MD ugasen ranije, pred BF */    /* 30.10.2026 23:59:59 Beograd (okvirno, Ivan potvrdjuje) */
  var cpPreview = /[?&]cp_drop_preview=1/.test(location.search);
  try {
    if (cpPreview) sessionStorage.setItem('cpDropPrev', '1');
    if (sessionStorage.getItem('cpDropPrev') === '1') cpPreview = true;
  } catch (e) {}
  if (!cpPreview && (Date.now() < CP_POCETAK || Date.now() > CP_KRAJ)) return;

  var VAR = { m: 50896278782009, z: 50896278814777, u: 50896278847545 };
  var GRATIS_HANDLE = 'free-sample-box-gift';
  var PODRAZUMEVANI = VAR.u;
  /* 21.10 Ivan: Men's u magacinu 0 do 22.10 - sakriven iz izbora dok ne stigne (prazno = svi dostupni) */
  var SAKRIVENE = []; /* Ivan 21.10 23:44: nista se ne sklanja, greske u magacinu resava CS */
  var lang = ((document.documentElement.lang || 'en') + '').toLowerCase();
  var L = lang.split('-')[0];
  var T = {
    de: ['👇 Wähle deine Probenbox:', 'Herren', 'Damen', 'Unisex', '🎁 Dein Geschenk: Gratis-Probenbox'],
    hr: ['👇 Odaberi svoju kutiju uzoraka:', 'Muška', 'Ženska', 'Unisex', '🎁 Tvoj poklon: kutija uzoraka gratis'],
    sl: ['👇 Izberi svojo škatlico vzorcev:', 'Moška', 'Ženska', 'Unisex', '🎁 Tvoje darilo: brezplačna škatlica vzorcev'],
    it: ['👇 Scegli il tuo box di campioni:', 'Uomo', 'Donna', 'Unisex', '🎁 Il tuo regalo: box di campioni in omaggio'],
    es: ['👇 Elige tu caja de muestras:', 'Hombre', 'Mujer', 'Unisex', '🎁 Tu regalo: caja de muestras gratis'],
    pt: ['👇 Escolhe a tua caixa de amostras:', 'Homem', 'Mulher', 'Unisex', '🎁 O teu presente: caixa de amostras grátis'],
    nl: ['👇 Kies je proefdoos:', 'Heren', 'Dames', 'Unisex', '🎁 Jouw cadeau: gratis proefdoos'],
    pl: ['👇 Wybierz swoje pudełko próbek:', 'Męskie', 'Damskie', 'Unisex', '🎁 Twój prezent: pudełko próbek gratis'],
    cs: ['👇 Vyber si krabičku vzorků:', 'Pánská', 'Dámská', 'Unisex', '🎁 Tvůj dárek: krabička vzorků zdarma'],
    sk: ['👇 Vyber si škatuľku vzoriek:', 'Pánska', 'Dámska', 'Unisex', '🎁 Tvoj darček: škatuľka vzoriek zadarmo'],
    hu: ['👇 Válaszd ki a mintadobozodat:', 'Férfi', 'Női', 'Unisex', '🎁 Ajándékod: ingyenes mintadoboz'],
    ro: ['👇 Alege-ți cutia de mostre:', 'Bărbați', 'Femei', 'Unisex', '🎁 Cadoul tău: cutie de mostre gratuită'],
    bg: ['👇 Избери своята кутия с мостри:', 'Мъжка', 'Дамска', 'Unisex', '🎁 Твоят подарък: безплатна кутия с мостри'],
    el: ['👇 Διάλεξε το κουτί δειγμάτων σου:', 'Ανδρικό', 'Γυναικείο', 'Unisex', '🎁 Το δώρο σου: δωρεάν κουτί δειγμάτων'],
    sv: ['👇 Välj din provlåda:', 'Herr', 'Dam', 'Unisex', '🎁 Din gåva: gratis provlåda'],
    en: ['👇 Choose your sample box:', "Men's", "Women's", 'Unisex', '🎁 Your gift: free sample box']
  };
  var t = T[L] || T.en;
  var PRIKAZ = {}; PRIKAZ[VAR.m] = t[1]; PRIKAZ[VAR.z] = t[2]; PRIKAZ[VAR.u] = t[3];
  var IMENA_EN = {}; IMENA_EN[VAR.m] = "Men's"; IMENA_EN[VAR.z] = "Women's"; IMENA_EN[VAR.u] = 'Unisex';
  var KVAL_ID = '8196357062713,8196358307897,8196357914681,8196357554233,8196358504505,8307045367865,8196357521465,8196357783609,8196358242361,8196358471737,8196358045753,8196358438969,8196357980217,8196358701113,8196357455929,8196357259321,8199854653497,8204064686137,8196357750841,8196358602809,8196356407353,8196357193785,8198295650361,8202815438905,8196437180473,8196357718073,8285869703225,8204070322233,8196357128249,8196356636729,8284548595769,8198966247481,8196358766649,8196358176825,8198932561977,8198281035833,8306975506489,8196356669497,8199056752697,8196357161017,8196356571193,8196358537273,8285870063673,8198970081337,8198297845817,8196358668345,8306934382649,8198960021561,8196357587001,8306969804857,8204069240889,8198956679225,8196357816377,8196356767801,8306958925881,8306918981689,8204064129081,8199014055993,8196356505657,8285890478137,8198924992569,8196357390393,8285880287289,8204069339193,8196358373433,8198282838073,8196356538425,8285870522425,8198298173497,8285870981177,8204069830713,8285895458873,8196357292089,8285905911865,8199011401785,8285908435001,8285897162809,8307057983545,8285893525561,8285891723321,8202790600761,8306925142073,8198943768633,8307054805049,8192033521721,8204062654521,8196358144057,8196358012985,8196357357625,8306990481465,8196358111289,8196358635577,8204058656825,8196356735033,8202807476281,8198936690745,8198296272953,8285879828537,8284547547193,8306966855737,8306963939385,8285888479289,8202808983609,8196357947449,8204071141433,8198299058233,8306928451641,8198285787193,8306931335225,8204065308729,8306955812921,8196357881913,8307000999993,8196358209593,8196356702265,8198978764857,8285896081465,8306987597881,8198941245497,8284548333625,8198948323385,8199055409209,8307047727161,8307043008569,8196357685305'.split(',');
  var radim = false;

  function cpZakljucaj(on) {
    document.querySelectorAll('#CartDrawer-Checkout,[name="checkout"]').forEach(function (b) {
      b.disabled = on;
      if (on) { b.setAttribute('aria-busy', 'true'); } else { b.removeAttribute('aria-busy'); }
    });
  }
  function jeGratis(item) { return item.handle === GRATIS_HANDLE; }
  function kvalifikuje(item) {
    if (jeGratis(item)) return false;
    if (!(item.final_price > 0)) return false;
    /* product_id iz kolekcije all-perfumes (parfemi + 3 for 55 + placene Sample Box), ne zavisi od jezika */
    if (KVAL_ID.indexOf(String(item.product_id)) !== -1) return true;
    if (item.properties && item.properties._bundle_type) return true;
    return false;
  }

  function ofarbaj(data) {
    if (!data || !data.sections) { osveziPrikaz(); return; }
    if (data.sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
      var novi = doc.getElementById('CartDrawer');
      var stari = document.getElementById('CartDrawer');
      if (novi && stari) stari.innerHTML = novi.innerHTML;
      var cd = document.querySelector('cart-drawer');
      if (cd) { if (data.item_count === 0) { cd.classList.add('is-empty'); } else { cd.classList.remove('is-empty'); } }
    }
    var b = document.getElementById('cart-icon-bubble');
    if (b && data.sections['cart-icon-bubble']) b.innerHTML = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html').body.innerHTML;
    setTimeout(doteraj, 150);
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); }
  }
  function osveziPrikaz() {
    if (document.getElementById('CartDrawer')) {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
        ofarbaj({ sections: s, item_count: 1 });
      }).catch(function () {});
    } else if (/\/cart\/?$/.test(location.pathname)) { location.reload(); }
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function sprovedi() {
    if (radim) return;
    radim = true;
    fetch(R + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var gratis = null, kval = false;
      cart.items.forEach(function (i) { if (jeGratis(i)) gratis = i; else if (kvalifikuje(i)) kval = true; });
      if (kval && !gratis) {
        cpZakljucaj(true);
        return post(R + 'cart/add.js?cpDrop=1', { id: PODRAZUMEVANI, quantity: 1, sections: 'cart-drawer,cart-icon-bubble' })
          .then(function (d) { radim = false; ofarbaj(d); cpZakljucaj(false); });
      }
      if (gratis && !kval) {
        cpZakljucaj(true);
        return post(R + 'cart/change.js?cpDrop=1', { id: gratis.key, quantity: 0, sections: 'cart-drawer,cart-icon-bubble' })
          .then(function (d) { radim = false; ofarbaj(d); cpZakljucaj(false); });
      }
      if (gratis && SAKRIVENE.indexOf(gratis.variant_id) !== -1) {
        cpZakljucaj(true);
        var up = {}; up[gratis.variant_id] = 0; up[PODRAZUMEVANI] = 1;
        return post(R + 'cart/update.js?cpDrop=1', { updates: up, sections: 'cart-drawer,cart-icon-bubble' })
          .then(function (d) { radim = false; ofarbaj(d); cpZakljucaj(false); });
      }
      if (gratis && gratis.quantity > 1) {
        cpZakljucaj(true);
        return post(R + 'cart/change.js?cpDrop=1', { id: gratis.key, quantity: 1, sections: 'cart-drawer,cart-icon-bubble' })
          .then(function (d) { radim = false; ofarbaj(d); cpZakljucaj(false); });
      }
      radim = false;
      doteraj();
    }).catch(function () { radim = false; cpZakljucaj(false); });
  }
  window.cpDropEnforce = sprovedi;

  function doteraj() {
    document.querySelectorAll('a[href*="' + GRATIS_HANDLE + '"]').forEach(function (a) {
      var red = a.closest('.cart-item') || a.closest('tr') || a.closest('[id^="CartDrawer-Item"], [id^="CartItem"]');
      if (!red || red.querySelector('.cp-drop-blok')) return;
      red.querySelectorAll('quantity-input, .cart-item__quantity-wrapper, .quantity').forEach(function (q) { q.style.display = 'none'; });
      var ime = red.querySelector('.cart-item__name') || a;
      if (ime && ime.tagName === 'A') {
        /* Nikola 26.10 (Anja/Milica, kao SR/BA): "🎁 Your gift:" u prvom redu, naziv kutije u drugom */
        var dv = t[4].indexOf(':');
        if (dv > -1) {
          ime.textContent = '';
          var oz = document.createElement('span'); oz.className = 'cp-poklon-oznaka'; oz.textContent = t[4].slice(0, dv + 1);
          var tx = document.createElement('span'); tx.className = 'cp-poklon-tekst'; var nz = t[4].slice(dv + 1).trim(); tx.textContent = nz.charAt(0).toUpperCase() + nz.slice(1); /* Anja 26.10: velikim slovom */
          ime.appendChild(oz); ime.appendChild(tx);
        } else { ime.textContent = t[4]; }
      }
      var sel = document.createElement('select');
      sel.className = 'cp-drop-select';
      sel.setAttribute('aria-label', t[0].replace('👇 ', ''));
      [VAR.m, VAR.z, VAR.u].filter(function (v) { return SAKRIVENE.indexOf(v) === -1; }).forEach(function (v) { var o = document.createElement('option'); o.value = v; o.textContent = PRIKAZ[v]; sel.appendChild(o); });
      var tekst = red.textContent, trenutna = null;
      [VAR.m, VAR.z, VAR.u].forEach(function (v) { if (tekst.indexOf(IMENA_EN[v]) !== -1) trenutna = v; });
      if (trenutna) sel.value = trenutna;
      sel.addEventListener('change', function () {
        var novi = Number(sel.value);
        sel.disabled = true; radim = true; cpZakljucaj(true);
        fetch(R + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var g = cart.items.filter(jeGratis)[0];
          if (!g) return null;
          var updates = {}; updates[g.variant_id] = 0; updates[novi] = 1;
          return post(R + 'cart/update.js?cpDrop=1', { updates: updates, sections: 'cart-drawer,cart-icon-bubble' });
        }).then(function (d) { radim = false; ofarbaj(d); cpZakljucaj(false); })
          .catch(function () { radim = false; sel.disabled = false; cpZakljucaj(false); });
      });
      var blok = document.createElement('div'); blok.className = 'cp-drop-blok';
      var lab = document.createElement('div'); lab.className = 'cp-drop-lab'; lab.textContent = t[0].replace('👇 ', ''); /* Nikola 26.10: bez emoji ruke, kao SR/BA */
      blok.appendChild(lab); blok.appendChild(sel);
      ime.parentNode.insertBefore(blok, ime.nextSibling);
      if (!document.getElementById('cp-drop-stil')) {
        var stil = document.createElement('style'); stil.id = 'cp-drop-stil';
        stil.textContent = '.cp-drop-blok{display:block;margin:.6rem 0 .2rem;padding:.6rem .7rem;background:#FFEDE2;border:.15rem solid #AD421A;border-radius:.8rem;max-width:22rem}' +
          '.cp-drop-lab{font-size:1.15rem;font-weight:700;color:#3a3a3a;margin-bottom:.4rem;line-height:1.25}' +
          '.cp-drop-select{display:block;width:100%;font-size:1.4rem;font-weight:600;padding:.55rem .7rem;border:.15rem solid #AD421A;border-radius:.6rem;background:#fff;color:#AD421A;cursor:pointer}' +
          '.cart-item:has(a[href*="free-sample-box-gift"]) quantity-input,.cart-item:has(a[href*="free-sample-box-gift"]) .quantity,' +
          '.cart-item:has(a[href*="free-sample-box-gift"]) cart-remove-button,tr:has(a[href*="free-sample-box-gift"]) quantity-input,' +
          'tr:has(a[href*="free-sample-box-gift"]) .quantity,.cart-item:has(a[href*="free-sample-box-gift"]) .cp-qty{display:none!important}';
        document.head.appendChild(stil);
      }
    });
  }

  var stariFetch = window.fetch;
  window.fetch = function () {
    var arg = arguments[0];
    var p = stariFetch.apply(this, arguments);
    try {
      var u = typeof arg === 'string' ? arg : (arg && arg.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(u) && u.indexOf('cpDrop') === -1) { p.then(function () { setTimeout(sprovedi, 150); }); }
    } catch (e) {}
    return p;
  };
  function cpStart() { setTimeout(sprovedi, 350); setTimeout(sprovedi, 1600); setTimeout(sprovedi, 3500); }
  setInterval(function () { try { if (document.querySelector('a[href*="' + GRATIS_HANDLE + '"]') && !document.querySelector('.cp-drop-blok')) sprovedi(); } catch (e) {} }, 4000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cpStart); else cpStart();
})();
